export default __webpack_public_path__ + "7f1abce1e1f21692db69eeb73f5dbfab.png";